import { render, staticRenderFns } from "./DynamicLandingPage.vue?vue&type=template&id=38f255c6&scoped=true&"
import script from "./DynamicLandingPage.vue?vue&type=script&lang=js&"
export * from "./DynamicLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./DynamicLandingPage.vue?vue&type=style&index=0&id=38f255c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f255c6",
  null
  
)

export default component.exports